import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className='privacy-policy-container'>
      <div className='privacy-content'>
        <h1>Privacy Policy</h1>
        <p>Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>
        
        <section>
          <h2>1. Informazioni Generali</h2>
          <p>
            Questa Privacy Policy descrive come raccogliamo, utilizziamo e proteggiamo 
            le tue informazioni personali quando visiti il nostro sito web.
          </p>
        </section>

        <section>
          <h2>2. Dati che Raccogliamo</h2>
          <h3>2.1 Cookie Necessari</h3>
          <p>
            Questi cookie sono essenziali per il funzionamento del sito web e non possono 
            essere disabilitati. Includono preferenze di consenso e impostazioni tecniche necessarie.
          </p>

          <h3>2.2 Cookie Analitici</h3>
          <p>
            Utilizziamo Google Analytics per comprendere come i visitatori interagiscono con il nostro sito.
            Questi dati ci aiutano a migliorare l'esperienza utente. I dati raccolti includono:
          </p>
          <ul>
            <li>Pagine visitate</li>
            <li>Tempo trascorso sul sito</li>
            <li>Dispositivo e browser utilizzati</li>
            <li>Localizzazione geografica approssimativa</li>
          </ul>

          <h3>2.3 Cookie di Marketing</h3>
          <p>
            Questi cookie ci permettono di mostrare annunci pertinenti e misurare l'efficacia 
            delle nostre campagne pubblicitarie su Google Ads e altre piattaforme.
          </p>

          <h3>2.4 Cookie di Funzionalità</h3>
          <p>
            Permettono al sito di ricordare le tue preferenze e fornire funzionalità migliorate.
          </p>
        </section>

        <section>
          <h2>3. Come Utilizziamo i Tuoi Dati</h2>
          <ul>
            <li>Per fornire e migliorare i nostri servizi</li>
            <li>Per rispondere alle tue richieste di contatto</li>
            <li>Per analizzare l'utilizzo del sito web</li>
            <li>Per mostrare contenuti e annunci pertinenti</li>
            <li>Per rispettare gli obblighi legali</li>
          </ul>
        </section>

        <section>
          <h2>4. Condivisione dei Dati</h2>
          <p>
            Non vendiamo, scambiamo o trasmettiamo i tuoi dati personali a terze parti, 
            eccetto nei seguenti casi:
          </p>
          <ul>
            <li>Fornitori di servizi autorizzati (Google Analytics, Google Ads)</li>
            <li>Quando richiesto dalla legge</li>
            <li>Per proteggere i nostri diritti legali</li>
          </ul>
        </section>

        <section>
          <h2>5. I Tuoi Diritti</h2>
          <p>Hai il diritto di:</p>
          <ul>
            <li>Accedere ai tuoi dati personali</li>
            <li>Rettificare dati inaccurati</li>
            <li>Richiedere la cancellazione dei tuoi dati</li>
            <li>Limitare il trattamento dei tuoi dati</li>
            <li>Ritirare il consenso in qualsiasi momento</li>
            <li>Presentare un reclamo all'autorità di controllo</li>
          </ul>
        </section>

        <section>
          <h2>6. Sicurezza dei Dati</h2>
          <p>
            Implementiamo misure di sicurezza appropriate per proteggere i tuoi dati personali 
            contro accesso non autorizzato, alterazione, divulgazione o distruzione.
          </p>
        </section>

        <section>
          <h2>7. Gestione dei Cookie</h2>
          <p>
            Puoi gestire le tue preferenze sui cookie in qualsiasi momento attraverso 
            il banner di consenso che appare sul nostro sito web. Puoi anche configurare 
            il tuo browser per rifiutare tutti i cookie, ma questo potrebbe limitare 
            alcune funzionalità del sito.
          </p>
        </section>

        <section>
          <h2>8. Modifiche a questa Privacy Policy</h2>
          <p>
            Ci riserviamo il diritto di aggiornare questa Privacy Policy in qualsiasi momento. 
            Le modifiche saranno pubblicate su questa pagina con una nuova data di aggiornamento.
          </p>
        </section>

        <section>
          <h2>9. Contatti</h2>
          <p>
            Per qualsiasi domanda riguardo questa Privacy Policy o per esercitare i tuoi diritti, 
            puoi contattarci all'indirizzo email: jacopo.biraschi@gmail.com
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
